import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import { AdsGETApi, AdsGETApiAuth, sideBarImage } from '../../../Constant/api';
import { slugs } from '../../../Constant/slugs';

export default function AllBooksView(props) {
  const { navigation } = props;
  // const { type, title } = props.route.params;
  const [AllExamList1, setAllExamList1] = React.useState([]);
  const [AllExamList, setAllExamList] = React.useState([]);
  const [reload, setReload] = React.useState(false)
  const LoginState = useSelector((state) => state.LoginState);
  const [usersData, setUsersData] = React.useState({ meta: { number_of_exams: "0" } });
  const [AllExamListUnavailable, setAllExamListUnavailable] = React.useState([]);
  const [AllExamListUnavailable1, setAllExamListUnavailable1] = React.useState([]);
  const [VerifiedvExams, setVerifiedExam] = React.useState([]);
  const [FreeBooks, setFreeBooks] = React.useState([]);
  const location = useLocation()
  var type = location.pathname.slice(slugs.book_list_user.length + 1) == "" ? "ubt" : location.pathname.slice(slugs.book_list_user.length + 1)
  const history = useHistory()

  const typeArray = {
    "book": "Book",
    "videos": "Videos",
    "skill-test": "Materi Skill Test",
  }

  const fetchExam = (perPage,) => {
    setReload(true)
    const date = new Date()
    setAllExamList1([])
    AdsGETApiAuth({
      ...perPage,
    }, slugs.db_slug_book)
      .then((res) => {
        setReload(false)
        setAllExamList1(res.data)
      })
      .catch(err => {
        console.log(err)
        console.log(err.response.data)
      })
  }
  useEffect(() => {
    var type;
    type = location.pathname.slice(slugs.book_list_user.length + 1) == "" ? "book" : location.pathname.slice(slugs.book_list_user.length + 1)
    console.log(type)

    fetchExam({
      per_page: 1000,
      order: "asc",
      _fields: "id,title,meta,slug",
      "filter[meta_query][1][key]": "book_type",
      "filter[meta_query][1][value][0]": `${typeArray[type]}`,
      "filter[meta_query][1][compare]": "=",
    })
    return history.listen((location) => {
      if (location.pathname.includes(slugs.book_list_user)) {
        type = location.pathname.slice(slugs.book_list_user.length + 1) == "" ? "book" : location.pathname.slice(slugs.book_list_user.length + 1)
        window.scrollTo(0, 0)
        fetchExam({
          per_page: 1000,
          order: "asc",
          _fields: "id,title,meta,slug",
          "filter[meta_query][1][key]": "book_type",
          "filter[meta_query][1][value][0]": `${typeArray[type]}`,
          "filter[meta_query][1][compare]": "=",
        })
      }
    })
  }, [])

  return (
    <div style={{ backgroundColor: "#eee", minHeight: "90vh" }}>
      <div>
        <div className="row">
          <div className="col-sm-2 col-12"></div>
          <div className="col-sm-8 col-12 form-view m-3">

            <div className="row">
              {AllExamList1.map((item, index) => (
                <div key={index} className="col-sm-3">
                  <Link to={`${slugs.book_details_student}/${item.slug}`}>
                    <div style={{
                      padding: "5px", margin: "5px 0px", border: "1.5px solid #bbb",
                      borderRadius: "5px", color: "#000"
                    }}>
                      {/* <BookView item={item} navigation={navigation} /> */}
                      {item.title.rendered}
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

